'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StickyHeader = function () {
  function StickyHeader() {
    (0, _classCallCheck3.default)(this, StickyHeader);

    this.els = {
      header: document.querySelector('.hd-Header'),
      site: document.querySelector('.lyt-Site'),
      slides: document.querySelector('.hd-Header_PromoCarousel')
    };

    this.colouredHeaderOffset = 50;
    this.lastKnownScrollY = 0;
    this.offsetTrackedY = 0;
    this.scrollDirection = '';
    this.isTicking = false;
    this.offset = 250;

    this.setupListeners();

    this.onScroll = this.onScroll.bind(this);
    this.updateFixed = this.updateFixed.bind(this);

    if (this.els.slides && this.els.slides.children.length > 0) {
      var _perPage;

      this.itemsPerSlide = parseInt(this.els.slides.dataset.itemsPerSlide, 10);
      this.autoplayIntervalSeconds = parseInt(this.els.slides.dataset.autoplay, 10) || 0;

      this.carousel = new _siema2.default({
        selector: this.els.slides,
        duration: 500,
        loop: true,
        perPage: (_perPage = {}, (0, _defineProperty3.default)(_perPage, _utils.mediaBreakpoints.sm, 1), (0, _defineProperty3.default)(_perPage, _utils.mediaBreakpoints.md, this.itemsPerSlide), _perPage),
        draggable: true
      });

      // Start autoplay
      this.startAutoplay();
    }

    // Fire the onScroll event so we can capture initial values
    this.onScroll();
  }

  (0, _createClass3.default)(StickyHeader, [{
    key: 'setupListeners',
    value: function setupListeners() {
      window.addEventListener('scroll', this.onScroll.bind(this), {
        passive: true
      });
    }
  }, {
    key: 'startAutoplay',
    value: function startAutoplay() {
      var _this = this;

      this.stopAutoplay();

      if (this.autoplayIntervalSeconds > 0) {
        this.autoplayInterval = setInterval(function () {
          _this.carousel.next();
        }, this.autoplayIntervalSeconds * 1000);
      }
    }
  }, {
    key: 'stopAutoplay',
    value: function stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      // All we want to do here is set the scrollY, we'll delegate the intensive stuff to rAF to
      // ensure 60 FPS
      var previouslyKnown = this.lastKnownScrollY;
      var previousDirection = this.scrollDirection;
      this.lastKnownScrollY = window.scrollY;
      this.scrollDirection = previouslyKnown < this.lastKnownScrollY ? 'down' : 'up';

      if (previousDirection !== this.scrollDirection) {
        this.offsetTrackedY = this.lastKnownScrollY;
      }

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) requestAnimationFrame(this.updateFixed);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateFixed',
    value: function updateFixed() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      if (this.lastKnownScrollY > this.els.header.offsetHeight) {
        var shouldBeShown = this.lastKnownScrollY <= this.offsetTrackedY - this.offset && this.scrollDirection === 'up' || this.lastKnownScrollY >= this.offsetTrackedY + this.offset && this.scrollDirection === 'up';
        this.els.site.classList.toggle('lyt-Site-showHeader', shouldBeShown);
      } else {
        this.els.site.classList.add('lyt-Site-showHeader');
      }

      this.els.site.classList.toggle('lyt-Site-headerColoured', this.lastKnownScrollY > this.els.header.offsetHeight + this.colouredHeaderOffset);
    }
  }]);
  return StickyHeader;
}();

exports.default = StickyHeader;